import React, { useEffect, useState } from 'react';
import {
    Paper,
    Group,
    Progress,
    Box,
    SimpleGrid,
    RingProgress,
    Center,
    Text
} from '@mantine/core';
import DashboardDataService from '../../../../services/dashboard-activities';
import { BarChart, AreaChart } from '@mantine/charts';

import { useMantineTheme } from '@mantine/core';

const itemHeight = 120;

const CustomTooltip = ({ active, payload, label }) => {
    const theme = useMantineTheme();
    if (!active || !payload || payload.length === 0) return null;

    // background adapts to light/dark mode
    const backgroundColor =
        theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white;
    const textColor =
        theme.colorScheme === 'dark' ? theme.colors.gray[0] : theme.black;
    const borderColor =
        theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3];
    const seenNames = new Set();

    return (
      <div
        style={{
          width: 250,            // fixed width
          //maxWidth: 250,         // max width
          backgroundColor,
          border: `1px solid ${borderColor}`,
          borderRadius: 4,
          padding: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          pointerEvents: 'none', // prevents blocking hover interactions
          color: textColor
        }}
      >
        <div style={{ fontWeight: 'bold', marginBottom: 4 }}>{label}</div>
        
        {payload.filter((entry) => {
            if (seenNames.has(entry.name)) return false;
            seenNames.add(entry.name);
            return true;
        }).map((entry, idx) => (
          <div key={idx} style={{ display: 'flex', alignItems: 'center', fontSize: 14, marginBottom: 2 }}>
            <span
                style={{
                display: 'inline-block',
                width: 10,
                height: 10,
                borderRadius: '50%',
                backgroundColor: entry.color,
                marginRight: 6,
                }}
            />
            <span style={{display: "flex", justifyContent: 'space-between', flex: 1}}><span>{entry.name}</span> <span>{entry.value}</span></span>
        </div>
        ))}
      </div>
    );
};

export default function TicketsByMonth(props) {
    const [data, setData] = useState([]);

    useEffect(() => {
        if (props.loggedStatus.loggedIn) {
            var currentYear = new Date().getFullYear();
            var currentMonth = new Date().getMonth();
            //console.log("Current month is: ", currentMonth);
            console.log("timezone adjustment factor being sent to backend: ", props.loggedStatus.timezone_adjustment_factor);
            DashboardDataService.getTicketsIndividualMonth(props.loggedStatus.id, 0, currentYear, currentMonth, props.loggedStatus.timezone_adjustment_factor).then(response => {
                for (var i = 0; i < response.data.results.length; i++) {
                    response.data.results[i].numericMonth = response.data.results[i].month;     // save the month in number form
                    switch (response.data.results[i].month) {
                        case 1:
                            response.data.results[i].month = "Jan";
                            break;
                        case 2:
                            response.data.results[i].month = "Feb";
                            break;
                        case 3:
                            response.data.results[i].month = "Mar";
                            break;
                        case 4:
                            response.data.results[i].month = "Apr";
                            break;
                        case 5:
                            response.data.results[i].month = "May";
                            break;
                        case 6:
                            response.data.results[i].month = "Jun";
                            break;
                        case 7:
                            response.data.results[i].month = "Jul";
                            break;
                        case 8:
                            response.data.results[i].month = "Aug";
                            break;
                        case 9:
                            response.data.results[i].month = "Sep";
                            break;
                        case 10:
                            response.data.results[i].month = "Oct";
                            break;
                        case 11:
                            response.data.results[i].month = "Nov";
                            break;
                        case 12:
                            response.data.results[i].month = "Dec";
                            break;
                    }
                    response.data.results[i]["Tickets Created"] = response.data.results[i]["createdCount"];
                    delete response.data.results[i]["createdCount"];
                    response.data.results[i]["Tickets Solved"] = response.data.results[i]["solvedCount"];
                    delete response.data.results[i]["solvedCount"];
                }

                setData(response.data.results.sort((a, b) => {
                    const aIndex = (a.numericMonth - 1 + 11 - currentMonth) % 12;
                    const bIndex = (b.numericMonth - 1 + 11 - currentMonth) % 12;
                    return aIndex - bIndex;
                }))

                //setData(response.data.results);
            }).catch(e => {
                console.log(e);
            })
        }
    }, []);

    return (
        <Paper withBorder radius="md" h="100%" w="100%" style={{ verticalAlign: "top" }}>
            <Text p="20px">Tickets by Month <span style={{fontSize: "8pt"}}><i>{`(current month is projected)`}</i></span></Text>
            <AreaChart
                h={props.widget.size.y * itemHeight - 90}
                m={0}
                pr="20px"
                data={data}
                dataKey="month"
                series={[
                    {
                        name: 'Tickets Created',
                        color: 'blue.6',
                    },
                    {
                        name: 'Tickets Solved',
                        color: 'green.6',
                    },
                ]}
                tickLine="y"
                withTooltip
                tooltipProps={{
                    content: <CustomTooltip />,  // use custom tooltip
                    cursor: { stroke: 'rgba(128,128,128,0.6)', strokeWidth: 1 }, // hover line
                }}
                /* tooltipProps={{
                    //wrapperStyle: { pointerEvents: 'none' }, // prevents blocking hover
                    contentStyle: { 
                        background: 'red', 
                        border: '1px solid #ccc' 
                    },
                    cursor: { fill: 'rgba(0,0,0,0.05)' },   // nice hover highlight
                }} */
            />
        </Paper>
    );
}
